import { gql } from '@apollo/client';
export const StatPermissionsChild = gql `
    query StatPermissionsChild($childId: ChildId!) {
        attendance {
            management {
                customRegistrationForm {
                    forChild(childId: $childId) {
                        canViewSubmissions
                        canViewStatuses
                    }
                }
            }
        }
        childProfile {
            additionalNeeds {
                permissions(childId: $childId) {
                    canView
                    canEdit
                }
            }
        }
    }
`;
